export default "__VITE_ASSET__RF2KKQ7R__"